export enum MiniMessageActionTypes {
  SHOW_MINI_MESSAGE_BOX = "SHOW_MINI_MESSAGE_BOX",
  HIDE_MINI_MESSAGE_BOX = "HIDE_MINI_MESSAGE_BOX",
}
